/**
 * This will handle the video post roll
 * @example ng-video-post-roll=""
 */

const ngVideoPostRoll = [() => {
    return {
        link: function ($scope, $element, $params) {
            let $video = $element[0];
            $video.addEventListener('timeupdate', () => {
                $scope.postRoll.progress = parseInt($video.currentTime / $video.duration * 100);
                if ( $video.currentTime >= $scope.postRoll.skipDelay && $scope.postRoll.skipShow === false ) {
                    $scope.postRoll.skipShow = true;
                    $scope.$apply();
                    return false;
                }
                if ( $scope.postRoll.skipShow === false ) {
                    $scope.postRoll.skipRemain = $scope.postRoll.skipDelay - parseInt($video.currentTime);
                    $scope.$apply();
                    return false;
                }
                $scope.$apply();
            });

            $video.addEventListener('ended', () => {
                if ( $scope.hasOwnProperty('player')) {
                    $scope.postRoll.available = false;
                    $scope.player.pause = true;
                    $scope.$apply();
                    setTimeout(() => {
                        $scope.postRoll.finished = true;
                        $scope.player.pause = false;
                        $scope.$apply();
                    }, 1500);
                } else {
                    $scope.postRoll.available = false;
                    $scope.postRoll.finished = true;
                    $scope.$apply();
                }
            });

            $video.addEventListener('error', () => {
                $scope.postRoll.available = false;
                $scope.bunny.playPause();
            });

            $scope.$watch('postRoll.started', ($started) => {
                if ($started) {
                    $video.play();
                }
            });


        }
    }
}];

export default ngVideoPostRoll;

